/**
 * Given a breadcrumb trail it returns a truncated result if the trail's
 * length is larger than maxCrumbs.
 *
 * @param {Array<Object>} trail The breadcrumb trail.
 * @param {number} [maxCrumbs] Limit over which the trail should be truncated.
 * @param {number} [activeIndex] The active crumb.
 * @returns {{ trail: Array<Object>, skipped: Array<Object> }}
 */
export const getTruncatedBreadcrumbTrail = (
  trail,
  maxCrumbs = 4,
  activeIndex,
) => {
  const mappedTrail = trail.map((crumb, index) => ({
    ...crumb,
    active:
      activeIndex == null ? index === trail.length - 1 : activeIndex === index,
  }));

  if (maxCrumbs >= trail.length) {
    return {
      trail: mappedTrail,
      skipped: [],
    };
  }

  // If the trail is longer than maxCrumbs get only the 2 first and 2 last crumbs
  const head = mappedTrail.slice(0, Math.floor(maxCrumbs / 2));
  const skipped = mappedTrail.slice(
    Math.floor(maxCrumbs / 2),
    mappedTrail.length - Math.floor(maxCrumbs / 2),
  );
  const tail =
    // Avoids tail becoming the entire array
    Math.floor(maxCrumbs / 2) === 0
      ? []
      : mappedTrail.slice(-Math.floor(maxCrumbs / 2));
  return {
    trail: [
      ...head,
      {
        label: '',
        ellipsis: true,
      },
      ...tail,
    ],
    skipped,
  };
};
